import {
  CounterpartyGroupSortOption,
  OperationType,
} from '@rematter/frontend-lib-api-client';

import { CounterpartyGroupRecord } from '../types/pricing';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const counterpartyGroupsListQueryAtom = createQueryAtomFactory(
  'brokerage.counterpartyGroupsList',
  (params: {
    ids?: string[];
    searchTerm?: string;
    operationTypes?: OperationType[];
    limit?: number;
    offset?: number;
    sorting?: CounterpartyGroupSortOption[];
  }) => ({
    counterpartyGroups: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          operationTypes: params.operationTypes,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        operationType: true,
        memberCount: true,
        updatedByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      counterpartyGroups: CounterpartyGroupRecord[];
      totalCount: number;
    } => {
      if (!data?.counterpartyGroups?.entries) {
        return { counterpartyGroups: [], totalCount: 0 };
      }

      return {
        counterpartyGroups: data.counterpartyGroups.entries.map((group) => ({
          id: group.id,
          name: group.name,
          operationType: group.operationType as OperationType,
          memberCount: group.memberCount ?? 0,
          updatedByUser: group.updatedByUser
            ? {
                id: group.updatedByUser.id,
                name: `${group.updatedByUser.firstName} ${group.updatedByUser.lastName}`.trim(),
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(group.timestamps.createdAt),
            updatedAt: parseZonedDateTime(group.timestamps.updatedAt),
          },
        })),
        totalCount: data.counterpartyGroups.page?.total ?? 0,
      };
    },
  },
);
